<template>
  <w-icon-wrapper icon-name='work-add-icon'>
    <g
      id='_65_außerhalb_des_Offices_Icon'
      data-name='65 außerhalb des Offices_Icon'
      transform='translate(0.102)'
    >
      <path
        id='Pfad_55771'
        d='M12,22H7.967V18H5.95v4H1.916V2H12V8.333h2.017V0H-.1V24H14.018V15.667H12Z'
        data-name='Pfad 55771'
        fill='currentColor'
      />
      <path
        id='Pfad_55772'
        d='M23.2,11.34a.957.957,0,0,0-.078-.078L20.155,8.3a1.013,1.013,0,0,0-1.426-.006A.994.994,0,0,0,18.723,9.7l1.3,1.3H13.388a1,1,0,1,0,0,2H20l-1.331,1.283a1,1,0,0,0-.02,1.414,1.014,1.014,0,0,0,1.426.02l3.819-3.68Z'
        data-name='Pfad 55772'
        fill='currentColor'
      />
      <ellipse
        id='Ellipse_1539'
        cx='1.009'
        cy='1'
        data-name='Ellipse 1539'
        fill='currentColor'
        rx='1.009'
        ry='1'
        transform='translate(3.933 4)'
      />
      <ellipse
        id='Ellipse_1540'
        cx='1.009'
        cy='1'
        data-name='Ellipse 1540'
        fill='currentColor'
        rx='1.009'
        ry='1'
        transform='translate(7.967 4)'
      />
      <ellipse
        id='Ellipse_1541'
        cx='1.009'
        cy='1'
        data-name='Ellipse 1541'
        fill='currentColor'
        rx='1.009'
        ry='1'
        transform='translate(3.933 8)'
      />
      <ellipse
        id='Ellipse_1542'
        cx='1.009'
        cy='1'
        data-name='Ellipse 1542'
        fill='currentColor'
        rx='1.009'
        ry='1'
        transform='translate(7.967 8)'
      />
      <ellipse
        id='Ellipse_1543'
        cx='1.009'
        cy='1'
        data-name='Ellipse 1543'
        fill='currentColor'
        rx='1.009'
        ry='1'
        transform='translate(3.933 12)'
      />
      <ellipse
        id='Ellipse_1544'
        cx='1.009'
        cy='1'
        data-name='Ellipse 1544'
        fill='currentColor'
        rx='1.009'
        ry='1'
        transform='translate(7.967 12)'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconAdd' };
</script>
